<template>
  <a-modal v-model="editMobilePhoneModal"
           title="更换绑定手机"
           :footer="null"
           :keyboard="false"
           :maskClosable="false"
           @cancel="handleCancel">
    <div class="login">
      <a-form :form="form"
              @submit="onSubmit">
        <a-form-item>
          <a-input size="large"
                   placeholder="请输入要绑定的新手机号码"
                   v-decorator="['mobile', {rules: [{ required: true, message: '请输入要绑定的新手机号码', whitespace: true}]}]">
            <a-icon slot="prefix"
                    type="mobile" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-row :gutter="8">
            <a-col :span="16">
              <a-input size="large"
                       placeholder="验证码"
                       v-decorator="['code', {rules: [{ required: true,message: '请输入验证码', whitespace: true}]}]">
                <a-icon slot="prefix"
                        type="mail" />
              </a-input>
            </a-col>
            <a-col :span="8">
              <a-button @click="requestCode()"
                        :disabled="disabled"
                        class="captcha-button"
                        size="large">{{ btnText }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item>
          <a-button :loading="submitLoading"
                    style="width: 100%;margin-top: 24px"
                    size="large"
                    htmlType="submit"
                    type="primary">提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { GetVerificationCodeByExpertEditPhone } from '@/views/login/api/LoginApi'
import { EditMobilePhone } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'EditMobilePhoneModal',
  data () {
    return {
      editMobilePhoneModal: false,
      submitLoading: false,
      form: this.$form.createForm(this),
      btnText: '获取验证码',
      disabled: false,
      expertId: ""
    }
  },
  methods: {
    async requestCode () {
      let mobile = this.form.getFieldValue('mobile')
      if (!mobile) {
        this.$warning({
          title: '请输入要绑定的新手机号码！'
        })
        return
      }
      const that = this
      this.disabled = true
      this.btnText = '请稍候...'
      try {
        let res = await GetVerificationCodeByExpertEditPhone(mobile)
        if (res.code !== 200) {
          that.$error({ content: res.msg })
          that.btnText = '获取验证码'
          that.disabled = false
          return
        }
        that.$message.success(res.msg)
        setTimeout(() => {
          let seconds = 60
          that.btnText = seconds + 's后获取'
          let countdown = setInterval(() => {
            if (seconds > 0) {
              that.btnText = seconds + 's后获取'
              --seconds
            } else {
              that.btnText = '获取验证码'
              that.disabled = false
              clearInterval(countdown)
            }
          }, 1000)
        }, 500)
      } catch (e) {
        that.$message.error(e.message)
      }
    },
    onSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.onHandleEditPhone(values)
      })
    },
    async onHandleEditPhone (values) {
      this.submitLoading = true
      values.id = this.expertId
      values.mobilePhone = values.mobile
      const res = await EditMobilePhone(values)
      if (res.code == 200) {
        this.$message.success("更换成功")
        this.$emit('success', values.mobile)
        this.editMobilePhoneModal = false
      } else {
        this.$message.error("更换失败")
      }
      this.submitLoading = false
    },
    handleCancel (e) {
      e.preventDefault()
      if (this.submitLoading) {
        this.$message.warning("正在提交中，请稍后...")
        return
      } else {
        this.editMobilePhoneModal = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>